import React from "react";

import "./styles.scss"
import ChatInsightsMain from "../../esg-chat/insights";

const RealEstateInsights = () => {
    return (
        <ChatInsightsMain model="RealEstate" />
    )
}

export default RealEstateInsights